import React, { useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
const modules = [{
  title: 'Functional Foundations™',
  description: 'Le basi professionali per costruire allenamenti funzionali efficaci e sicuri.'
}, {
  title: 'Movement Library™',
  description: 'Una libreria completa di esercizi organizzati per obiettivo, livello e applicazione pratica.'
}, {
  title: 'Session Builder System™',
  description: 'Costruisci lezioni professionali in pochi minuti grazie a template e strutture già pronte.'
}, {
  title: 'Ready-To-Use Workouts™',
  description: 'Allenamenti completi pronti da utilizzare immediatamente.'
}, {
  title: 'Progressive Programs™',
  description: 'Programmi strutturati che aiutano i clienti a migliorare nel tempo.'
}, {
  title: 'Coaching Mastery™',
  description: 'Strategie professionali di coaching, cueing e gestione dei gruppi.'
}];
export function ModulesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-5 bg-white" data-id="element-96">
      <div className="text-center mb-8" data-id="element-97">
        <h2 className="text-2xl font-heading font-bold text-petrol mb-3" data-id="element-98">
          LA SOLUZIONE CHE STAVI CERCANDO
        </h2>
        <p className="text-sm font-subheading font-bold text-sage mb-4" data-id="element-99">
          Un Sistema Professionale 6-in-1 Creato per Coach di Functional
          Training
        </p>
        <p className="font-subheading font-bold text-sm text-petrol mb-4" data-id="element-100">
          FUNCTIONAL READY™ 6-in-1 Complete System
        </p>

        <a href="#pricing" className="block mb-6" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/h9zfmASQDwvzTrNnkPRn2A/ChatGPT-Image-16-jun-2026_-21_22_56.webp" alt="FUNCTIONAL READY 6-in-1 Complete System" className="w-full h-auto object-contain max-w-[240px] mx-auto" loading="lazy" data-id="element-102" />
        </a>

        <div className="text-graphite text-sm leading-relaxed mb-6 text-left" data-id="element-103">
          <p className="mb-2 font-bold" data-id="element-104">
            FUNCTIONAL READY™ non è una semplice raccolta di esercizi.
          </p>
          <p data-id="element-105">
            È un sistema operativo professionale progettato per aiutarti a
            programmare più velocemente, insegnare con maggiore sicurezza e
            offrire allenamenti di qualità superiore.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3 mb-8" data-id="element-106">
        <p className="text-xs text-center text-graphite mb-2 italic" data-id="element-107">
          Tocca un modulo per leggere la descrizione
        </p>
        {modules.map((module, i) => <div key={i} className="border border-cream bg-cream/30" data-id="element-108">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 text-left flex justify-between items-center" data-id="element-109">
              <span className="font-bold text-petrol text-sm font-subheading" data-id="element-110">
                ✅ {module.title}
              </span>
              <span className="text-petrol text-lg font-bold" data-id="element-111">
                {openIndex === i ? '−' : '+'}
              </span>
            </button>
            {openIndex === i && <div className="px-4 pb-3 pt-1 text-graphite text-sm" data-id="element-112">
                {module.description}
              </div>}
          </div>)}
      </div>

      <div className="mt-4" data-id="element-113">
        <CTAButton className="!bg-petrol !border-[#132538]" data-id="element-114">
          👉 SÌ, VOGLIO ACCEDERE AL SISTEMA
        </CTAButton>
      </div>
    </section>;
}